(() => {
  const configEl = document.getElementById('pdp-free-gifts-config');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    return;
  }

  const parseDisplayedMoneyToCents = (text) => {
    if (!text) return 0;
    let cleaned = String(text).replace(/[^\d.,-]/g, '').trim();
    if (!cleaned) return 0;
    if (cleaned.includes(',') && cleaned.includes('.')) {
      cleaned =
        cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')
          ? cleaned.replace(/\./g, '').replace(',', '.')
          : cleaned.replace(/,/g, '');
    } else if (cleaned.includes(',')) {
      const parts = cleaned.split(',');
      cleaned = parts[parts.length - 1].length <= 2 ? cleaned.replace(',', '.') : cleaned.replace(/,/g, '');
    }
    const amount = parseFloat(cleaned);
    return Number.isNaN(amount) ? 0 : Math.round(amount * 100);
  };

  const normalizeCents = (value) => {
    if (value == null || value === '') return 0;
    if (typeof value === 'number') {
      if (value > 0 && value < 250) return Math.round(value * 100);
      return Math.round(value);
    }
    const raw = String(value).trim();
    if (raw.includes('.') || raw.includes(',')) return parseDisplayedMoneyToCents(raw);
    const parsed = parseInt(raw, 10);
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  const gidToId = (gid) => {
    if (!gid) return null;
    const parts = String(gid).split('/');
    return parts[parts.length - 1] || null;
  };

  const formatCents = (cents) => {
    const value = (Number(cents) || 0) / 100;
    if (!value) return '';
    return `$${value.toFixed(2)}`;
  };

  const escapeHtml = (value) =>
    String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');

  const getDealSettingsList = () => {
    const deals = [];
    document.querySelectorAll('script.kaching-bundles-deal-block-settings').forEach((script) => {
      try {
        deals.push(JSON.parse(script.textContent));
      } catch (error) {}
    });
    return deals;
  };

  const getKachingMarketId = () => {
    const script = document.getElementById('kaching-bundles-config');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent).marketId || null;
    } catch (error) {
      return null;
    }
  };

  const getKachingRoot = () =>
    document.querySelector('kaching-bundles-block, .kaching-bundles:not(.pdp-free-gifts)');

  const getSelectedBarEl = () =>
    document.querySelector('.kaching-bundles__bar--selected') ||
    document.querySelector('.kaching-bundles__bar input:checked')?.closest('.kaching-bundles__bar');

  const getProductCatalog = () => {
    const catalog = {};
    document.querySelectorAll('script.kaching-bundles-product').forEach((script) => {
      try {
        const product = JSON.parse(script.textContent);
        if (product && product.id != null) catalog[String(product.id)] = product;
      } catch (error) {}
    });
    return catalog;
  };

  const asGiftList = (value) => {
    if (Array.isArray(value)) return value.filter((item) => item && typeof item === 'object' && !Array.isArray(item));
    return [];
  };

  const isShippingGift = (gift) => {
    if (gift.productGID || gift.productId) return false;
    const type = String(gift.giftType || gift.type || '').toLowerCase();
    if (type === 'product') return false;
    return type === 'shipping' || /shipping/i.test(gift.text || gift.title || '');
  };

  const isRealGift = (gift) => {
    if (!gift || typeof gift !== 'object') return false;
    if (isShippingGift(gift)) return true;
    const type = String(gift.giftType || gift.type || '').toLowerCase();
    if (type === 'product' || gift.productGID || gift.productId) return true;
    const raw = String(gift.text || gift.title || '').replace(/^\+\s*/, '').trim();
    return !!(raw && !isMoneyOnlyLabel(raw) && !/^free\s+shipping$/i.test(raw));
  };

  const paintedBars = () =>
    Array.from(document.querySelectorAll('.kaching-bundles__bar')).filter((bar) => !bar.closest('.pdp-free-gifts'));

  const scoreDeal = (deal) => {
    let score = 0;
    paintedBars().forEach((barEl) => {
      const bar = (deal.dealBars || []).find((item) => item.id === barEl.getAttribute('data-deal-bar-id'));
      if (!bar) return;
      const gifts = asGiftList(bar.freeGifts).filter(isRealGift);
      const strips = barEl.querySelectorAll('.kaching-bundles__free-gift');
      score += 10;
      score += gifts.length;
      if (strips.length && gifts.length === strips.length) score += 80;
      if (strips.length > 1 && gifts.length > 1) score += 40;
      gifts.forEach((gift) => {
        if (gift.productGID || gift.productId) score += 25;
      });
    });
    return score;
  };

  const getActiveDeal = () => {
    const deals = getDealSettingsList();
    if (!deals.length) return null;
    let best = deals[0];
    let bestScore = -1;
    deals.forEach((deal) => {
      const score = scoreDeal(deal);
      if (score > bestScore) {
        best = deal;
        bestScore = score;
      }
    });
    return best;
  };

  const giftKey = (gift) => {
    if (isShippingGift(gift)) return 'shipping';
    return `product:${gidToId(gift.productGID || gift.productId) || gift.text || gift.id}`;
  };

  const giftImage = (gift, product) =>
    gift.image ||
    product?.featuredImage ||
    product?.featured_image ||
    product?.image ||
    product?.images?.[0]?.src ||
    product?.images?.[0] ||
    '';

  const giftTitle = (gift, product) => {
    if (isShippingGift(gift)) return 'Free Shipping';
    const raw = String(gift.text || gift.title || '').replace(/^\+\s*/, '').trim();
    if (raw && !/\{\{/.test(raw) && !parseDisplayedMoneyToCents(raw) && !/^free\s+gift$/i.test(raw)) return raw;
    return product?.title || 'Free gift';
  };

  const isMoneyOnlyLabel = (text) => {
    const cleaned = String(text || '')
      .replace(/^\+\s*/, '')
      .trim();
    if (!cleaned) return false;
    const leftover = cleaned.replace(/[\d.,\s$€£¥]/g, '');
    return leftover.length === 0 && parseDisplayedMoneyToCents(cleaned) > 0;
  };

  const giftValueCents = (gift, catalog) => {
    if (isShippingGift(gift)) {
      return (
        parseDisplayedMoneyToCents(gift.text) ||
        normalizeCents(gift.price || gift.value || gift.amount)
      );
    }
    const product = catalog[gidToId(gift.productGID || gift.productId)] || null;
    const variantIds = (gift.variantGIDs || gift.variantIds || []).map(gidToId).filter(Boolean);
    const variant =
      (product?.variants || []).find((item) => variantIds.includes(String(item.id))) || product?.variants?.[0];
    return normalizeCents(
      variant?.compareAtPrice ||
        variant?.compare_at_price ||
        product?.compareAtPrice ||
        product?.compare_at_price ||
        variant?.price ||
        product?.price
    );
  };

  const collectBarGifts = (deal) => {
    const raw = [];
    (deal.dealBars || []).forEach((bar) => {
      asGiftList(bar.freeGifts)
        .filter(isRealGift)
        .forEach((gift) => raw.push({ gift, barId: bar.id, barQty: Number(bar.quantity) || 0 }));
    });
    return raw;
  };

  const buildGifts = () => {
    const deal = getActiveDeal();
    if (!deal) return [];
    const catalog = getProductCatalog();
    const grouped = new Map();

    collectBarGifts(deal).forEach(({ gift, barId }) => {
      const key = giftKey(gift);
      const product = catalog[gidToId(gift.productGID || gift.productId)] || null;
      const existing = grouped.get(key);
      const next = {
        id: key,
        shipping: isShippingGift(gift),
        title: giftTitle(gift, product),
        image: giftImage(gift, product),
        price: giftValueCents(gift, catalog),
        barIds: new Set(existing?.barIds || []),
        includeInCompareAtByBar: { ...(existing?.includeInCompareAtByBar || {}) },
      };
      if (barId) {
        next.barIds.add(barId);
        next.includeInCompareAtByBar[barId] = gift.includeInCompareAt === true;
      }
      grouped.set(key, next);
    });

    return Array.from(grouped.values());
  };

  const getSelectedMeta = () => {
    const deal = getActiveDeal();
    const selectedEl = getSelectedBarEl();
    const bars = deal?.dealBars || [];
    const selectedId = selectedEl?.getAttribute('data-deal-bar-id');
    let barIndex = bars.findIndex((bar) => bar.id === selectedId);
    if (barIndex < 0 && selectedEl) {
      barIndex = Array.from(document.querySelectorAll('.kaching-bundles__bar')).indexOf(selectedEl);
    }
    const bar = barIndex >= 0 ? bars[barIndex] : null;
    const title = (selectedEl?.querySelector('.kaching-bundles__bar-title')?.textContent || '').trim();
    const quantity = Number(bar?.quantity) || Number((title.match(/(\d+)\s*pack/i) || [])[1]) || 1;
    return { barIndex, barId: selectedId, quantity };
  };

  const isUnlocked = (gift, selected) => !!(gift.barIds?.size && gift.barIds.has(selected.barId));

  const publishGiftTotals = (gifts, selected) => {
    const unlocked = gifts.filter((gift) => isUnlocked(gift, selected));
    const detail = {
      shippingCents: unlocked.filter((gift) => gift.shipping).reduce((sum, gift) => sum + (Number(gift.price) || 0), 0),
      productGiftCents: unlocked.filter((gift) => !gift.shipping).reduce((sum, gift) => sum + (Number(gift.price) || 0), 0),
      gifts: gifts.map((gift) => ({
        shipping: !!gift.shipping,
        title: gift.title,
        price: Number(gift.price) || 0,
        barIds: Array.from(gift.barIds || []),
        includeInCompareAtByBar: gift.includeInCompareAtByBar || {},
      })),
    };
    window.__pdpKachingGifts = detail;
    window.dispatchEvent(new CustomEvent('pdp-kaching-gifts:change', { detail }));
  };

  const ensureGiftMount = () => {
    const root = document.querySelector('.pdp-free-gifts');
    const kaching = getKachingRoot();
    if (root && kaching && kaching.nextElementSibling !== root) {
      kaching.insertAdjacentElement('afterend', root);
    }
    return root;
  };

  const hideNativeProgressiveGifts = () => {
    document
      .querySelectorAll('.kaching-bundles:not(.pdp-free-gifts) .kaching-bundles__progressive-gifts')
      .forEach((node) => {
        node.style.setProperty('display', 'none', 'important');
      });
  };

  const relabelBarGiftStrips = () => {
    document.querySelectorAll('.kaching-bundles__free-gift, .kaching-bundles__free-gifts').forEach((node) => {
      if (node.closest('.pdp-free-gifts')) return;
      if (node.style.getPropertyValue('display') === 'none') node.style.removeProperty('display');
    });

    const deal = getActiveDeal();
    const catalog = getProductCatalog();
    document.querySelectorAll('.kaching-bundles__bar').forEach((barEl) => {
      if (barEl.closest('.pdp-free-gifts')) return;
      const barId = barEl.getAttribute('data-deal-bar-id');
      const bar = (deal?.dealBars || []).find((item) => item.id === barId);
      const barGifts = asGiftList(bar?.freeGifts).filter(isRealGift);
      const strips = Array.from(barEl.querySelectorAll('.kaching-bundles__free-gift'));
      strips.forEach((strip, index) => {
        const gift = barGifts[index];
        if (!gift) return;
        const textEl = strip.querySelector('.kaching-bundles__free-gift__text') || strip;
        const product = catalog[gidToId(gift.productGID || gift.productId)] || null;
        const label = isShippingGift(gift) ? 'FREE SHIPPING' : giftTitle(gift, product);
        const next = `+ ${label}`;
        if ((textEl.textContent || '').trim() !== next) textEl.textContent = next;
      });
    });
  };

  const renderGiftCards = (gifts, selected) => {
    const root = ensureGiftMount();
    const grid = root?.querySelector('.pdp-free-gifts__grid');
    if (!root || !grid) return;
    if (!gifts.length) {
      root.hidden = true;
      return;
    }
    root.hidden = false;
    const html = gifts
      .map((gift) => {
        const unlocked = isUnlocked(gift, selected);
        const price = formatCents(gift.price);
        const lockedClass = unlocked ? '' : ' kaching-bundles__progressive-gifts__gift--locked';
        const shippingClass = gift.shipping ? ' pdp-kaching-gift--shipping' : '';
        const titleClass = unlocked ? '' : ' kaching-bundles__progressive-gifts__gift__title--locked';
        const image = gift.image
          ? `<img class="kaching-bundles__progressive-gifts__gift__image" src="${escapeHtml(gift.image)}" alt="">`
          : '';
        return `<article class="kaching-bundles__progressive-gifts__gift${shippingClass}${lockedClass}">
          <div class="kaching-bundles__progressive-gifts__gift__label">
            <span class="kaching-bundles__progressive-gifts__gift__label__text">FREE</span>
            ${
              price
                ? `<span class="kaching-bundles__progressive-gifts__gift__label__text kaching-bundles__progressive-gifts__gift__label__text--crossed-out">${escapeHtml(price)}</span>`
                : ''
            }
          </div>
          <div class="kaching-bundles__progressive-gifts__gift__content">
            <div class="kaching-bundles__progressive-gifts__gift__image-wrapper">${image}</div>
            <p class="kaching-bundles__progressive-gifts__gift__title${titleClass}">${escapeHtml(gift.title)}</p>
          </div>
        </article>`;
      })
      .join('');
    if (grid.innerHTML !== html) grid.innerHTML = html;
  };

  const logBarGifts = () => {
    if (window.__pdpKachingGiftsLogged) return;
    const deal = getActiveDeal();
    if (!deal) return;
    window.__pdpKachingGiftsLogged = true;
    const catalog = getProductCatalog();
    console.group('[PDP] Kaching bar free gifts');
    console.log('deal', deal.discountName, 'market', deal.marketId);
    (deal.dealBars || []).forEach((bar, index) => {
      const gifts = asGiftList(bar.freeGifts).filter(isRealGift);
      console.log(`bar ${index + 1} ${bar.title}`, gifts.map((gift) => ({
        giftType: gift.giftType,
        text: gift.text,
        showPrice: gift.showPrice,
        includeInCompareAt: gift.includeInCompareAt,
        priceCents: giftValueCents(gift, catalog),
        price: formatCents(giftValueCents(gift, catalog)),
        productGID: gift.productGID,
      })));
    });
    console.groupEnd();
  };

  const updateGifts = () => {
    hideNativeProgressiveGifts();
    relabelBarGiftStrips();
    const gifts = buildGifts();
    const selected = getSelectedMeta();
    renderGiftCards(gifts, selected);
    publishGiftTotals(gifts, selected);
    logBarGifts();
  };

  let started = false;

  const bindKaching = () => {
    const kaching = getKachingRoot();
    if (!kaching || kaching.dataset.giftsObserved === 'true') return;
    kaching.dataset.giftsObserved = 'true';
    new MutationObserver(updateGifts).observe(kaching, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'checked', 'aria-checked'],
    });
    kaching.addEventListener('click', () => {
      window.requestAnimationFrame(updateGifts);
      window.setTimeout(updateGifts, 50);
    });
    kaching.addEventListener('change', updateGifts);
  };

  const start = () => {
    if (started) {
      bindKaching();
      updateGifts();
      return;
    }
    started = true;
    updateGifts();
    bindKaching();

    if (!getKachingRoot()) {
      const bodyObserver = new MutationObserver(() => {
        if (getKachingRoot()) {
          bindKaching();
          updateGifts();
          bodyObserver.disconnect();
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }

    window.addEventListener('kaching-bundles-initialized', () => {
      bindKaching();
      updateGifts();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
